import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../../BaseComponent';
import { SortType, PersistentStore } from '../../../stores/PersistentStore';
import { LayoutType } from '../../../constants/LayoutConstants';
import { SelectBoxOption } from '../../../stores/SelectBoxStore';
import { PersistentActions } from '../../../actions/PersistentActions';
import { VisibilityStore } from '../../../stores/VisibilityStore';
import { PopupMenu } from '../../../constants/Enums';
import { VisibilityActions } from '../../../actions/VisibilityActions';
import { SelectBoxActions } from '../../../actions/SelectBoxActions';
import { PopupFlagPosition } from '../../../constants/PopupFlagPositions';
import { BasePopupMenu } from '../../popupmenu/BasePopupMenu';

interface ProjectSortButtonState {
    open: boolean;
    sortType: SortType;
}

interface ProjectsSortButtonProps extends React.Props<ProjectsSortButton> {
    layoutType: LayoutType;
}

export class ProjectsSortButton extends BaseComponent<ProjectsSortButtonProps, ProjectSortButtonState> {
    public static getOptions = (): Array<SelectBoxOption> => {
        return [
            {
                name: t('A-Z'), value: 'name-up',
                callback: () => { PersistentActions.setProjectSortType('name-up'); }, className: 'egr-select-option-noicon'
            },
            {
                name: t('Z-A'), value: 'name-down',
                callback: () => { PersistentActions.setProjectSortType('name-down'); }, className: 'egr-select-option-noicon'
            },
            {value: 'separator', name: 'separator', className: 'no-icon separator-option'},
            {
                name: t('Newest first'), value: 'date-down',
                callback: () => { PersistentActions.setProjectSortType('date-down'); }, className: 'egr-select-option-noicon'
            },
            {
                name: t('Oldest first'), value: 'date-up',
                callback: () => { PersistentActions.setProjectSortType('date-up'); }, className: 'egr-select-option-noicon'
            }
        ];
    };

    public componentWillMount(): void {
        this.addStoreListener(PersistentStore, this.onChange);
        this.addStoreListener(VisibilityStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element {
        if (this.props.layoutType === LayoutType.SMALL) {
            return (
                <div className="projects-sort-button" onClick={SelectBoxActions.showProjectsSortMenu}/>
            );
        }
        return (
            <BasePopupMenu
                defaultValue={this.state.sortType}
                className="projects-sort"
                flagPosition={PopupFlagPosition.TOPRIGHT}
                changeCallback={this.onSortToggle}
                toggleCallback={this.onSortToggle}
                open={this.state.open}
                options={ProjectsSortButton.getOptions()}
                title={{label: t('Sort by')}}
            />
        );
    }

    protected onChange = (): void => {
        this.setState({
            open: VisibilityStore.getState().popupMenu === PopupMenu.PROJECT_SORT,
            sortType: PersistentStore.getState().projectSort
        });
    };

    protected onSortChange = (pValue: SortType): void => {
        VisibilityActions.setPopupMenu(PopupMenu.NONE);
        PersistentActions.setProjectSortType(pValue);
    };

    protected onSortToggle = (pValue: boolean) => {
        VisibilityActions.setPopupMenu(this.state.open ? PopupMenu.NONE : PopupMenu.PROJECT_SORT);
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/projectmanager/ProjectsSortButton.tsx